import React, { useEffect, useRef, useState } from "react";
import { Table, Input, message, Spin, Modal } from "antd";
import Pagination from "../helpers/pagination";
import Column from "antd/es/table/Column";
import { isNotNullUndefined, formatDateTime } from "../helpers/common";
import { useFetchWithdrawalHistory } from "../services/withdrawalhistory.service"
import { storage } from "../utils/storage";
import { useNavigate } from "react-router-dom";


const ReferPaymentHistory: React.FC = () => {
    const { Search } = Input;
    const navigate = useNavigate();
    const [withdrawalsHistory, setWithdrawalsHistory] = useState<any[]>([]);
    const [isLoading, setIsLoading] = useState(false);
    const searchValue = useRef<string>("");
    const pageNumber = useRef(1);
    const [pageSize, setPageSize] = useState(10);
    const [totalPages, setTotalPages] = useState(1);
    const [selectedImage, setSelectedImage] = useState<string | null>(null);
    const [isModalVisible, setIsModalVisible] = useState(false);

    useEffect(() => {
        let userRoleId = parseInt(storage.getUserRoleId() ?? "0");
        if (![1, 4].includes(userRoleId)) {
            navigate("/");
        }
        else {
            getWithdrawalHistoryList("", "");
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const getWithdrawalHistoryList = async (searchFilter: string, userID: string) => {
        setIsLoading(true);
        getWithdrawalHistoryMutation.mutate({
            searchFilter: searchFilter,
            userID: userID
        });
    }

    const getWithdrawalHistoryMutation = useFetchWithdrawalHistory({
        onSuccess: (response: any) => {
            if (response.statusCode === 200) {
                if (isNotNullUndefined(response)) {
                    const formattedData = response.data.map((data: any) => ({
                        ...data,
                        totalAmountWithdrawn: `$${(data.totalAmountWithdrawn ?? 0).toFixed(2)}`,
                        createdAt: formatDateTime(data.createdAt, "DD/MM/YYYY HH:mm AMPM")
                    }));
                    setWithdrawalsHistory(formattedData);
                    const recordCount = formattedData[0]?.recordCount;
                    setTotalPages(Math.ceil(recordCount / pageSize));
                    setIsLoading(false);
                } else {
                    setWithdrawalsHistory([]);
                    setIsLoading(false);
                }
            }
            else {
                message.error(response.statusMessage);
                setIsLoading(false);
            }

        }, onError: (error) => {
            message.error(error.message);
            setIsLoading(false);
        }
    });

    //#region pagination operation
    const handlePageChange = (newPage: number) => {
        pageNumber.current = newPage;
        const size = pageSize;
        setPageSize(size);
    };

    const onSearch = (value: any) => {
        getWithdrawalHistoryList(value, "");
        searchValue.current = value;
    };

    const handleModalClose = () => {
        setIsModalVisible(false);
        setSelectedImage(null);
    };

    return (
        <div>
            <div className="flex justify-between align-middle pb-5">

                <h2 className="text-2xl font-semibold text-black">Refer Payment History</h2>
                <div className="flex justify-between gap-5">
                    <div className="w-80 max-w-80">
                        <Search
                            placeholder="Search History"
                            size="large"
                            enterButton
                            className="search-field"
                            onSearch={onSearch}
                        />
                    </div>
                </div>
            </div>

            <Table dataSource={withdrawalsHistory} className="userlist-table" bordered pagination={{ pageSize: pageSize, position: ['none'] }}
                locale={{
                    emptyText: isLoading ? <Spin /> : (
                        <div className="ant-empty">
                            <div className="ant-empty-image">
                                <svg width="64" height="41" viewBox="0 0 64 41" xmlns="http://www.w3.org/2000/svg">
                                    <g transform="translate(0 1)" fill="none" fillRule="evenodd">
                                        <ellipse fill="#f5f5f5" cx="32" cy="33" rx="32" ry="7"></ellipse>
                                        <g fillRule="nonzero" stroke="#d9d9d9">
                                            <path d="M55 12.76L44.854 1.258C44.367.474 43.656 0 42.907 0H21.093c-.749 0-1.46.474-1.947 1.257L9 12.761V22h46v-9.24z"></path>
                                            <path d="M41.613 15.931c0-1.605.994-2.93 2.227-2.931H55v18.137C55 33.26 53.68 35 52.05 35h-40.1C10.32 35 9 33.259 9 31.137V13h11.16c1.233 0 2.227 1.323 2.227 2.928v.022c0 1.605 1.005 2.901 2.237 2.901h14.752c1.232 0 2.237-1.308 2.237-2.913v-.007z" fill="#fafafa"></path>
                                        </g>
                                    </g>
                                </svg>
                            </div>
                            <div className="ant-empty-description">No data</div>
                        </div>
                    )
                }}>
                <Column title="User Name" dataIndex="userName" key="userName" align="center" />
                <Column title="Email" dataIndex="userEmail" key="userEmail" align="center" />
                <Column title="Total Amount Withdrawal" dataIndex="totalAmountWithdrawn" align="center" />
                <Column title="Created At" dataIndex="createdAt" key="createdAt" align="center" />
                <Column title="Comment" dataIndex="comment" align="center" />
                <Column title="Payment Proof"
                    dataIndex="paymentProofImage"
                    key="paymentProofImage"
                    align="center"
                    width={150}
                    render={(_: any, record: any) => (
                        <>
                            {record.paymentProofImage != null ? (
                                <a href={record.paymentProofImage} target="_blank" rel="noopener noreferrer">View Document</a>
                            ) : (
                                "Not Uploaded"
                            )}
                        </>
                    )}
                />
            </Table>
            <Modal open={isModalVisible} footer={null} onCancel={handleModalClose} className="image-gallery">
                {selectedImage && <img alt="Featured" style={{ width: '100%' }} src={selectedImage} />}
            </Modal>
            <div>
                <Pagination
                    currentPage={pageNumber.current}
                    totalPages={totalPages}
                    onPageChange={handlePageChange}
                />
            </div>
        </div>
    );
}

export default ReferPaymentHistory;
